import api from './api';
import { getApiUrl } from '../config/appConfig';

export interface UserAgentAccessTokenListItem {
  id: number;
  jti: string;
  name: string;
  createdAt: string;
  expiresAt: string;
  isRevoked: boolean;
  revokedAt?: string | null;
  lastUsedAt?: string | null;
  userId?: number | null;
  username?: string | null;
}

export interface CreateUserAgentAccessTokenRequest {
  name: string;
  expiresAt: string;
}

export interface UserAgentAccessTokenCreated {
  token: string;
  jti: string;
  expiresAt: string;
  name: string;
  tenantId: number;
  tenantCode?: string | null;
}

export interface UserAgentWhoAmI {
  username: string;
  displayName?: string | null;
  role?: string | null;
  currentTenantId?: number | null;
  currentTenantCode?: string | null;
  currentTenantName?: string | null;
  tenants: Array<{
    id: number;
    code: string;
    name: string;
    role?: string | null;
    isDefault: boolean;
  }>;
  permissions: string[];
  tokenUse?: string | null;
  jti?: string | null;
}

const base = '/api/me/agent-access-tokens';

export function buildMcpSnippet(tokenPlaceholder = `\${NEOS_AGENT_TOKEN}`): string {
  const apiRoot = getApiUrl().replace(/\/$/, '');
  const mcpUrl = `${apiRoot}/mcp`;
  return JSON.stringify(
    {
      mcp: {
        servers: {
          neos: {
            url: mcpUrl,
            transport: 'streamable-http',
            headers: {
              Authorization: `Bearer ${tokenPlaceholder}`,
            },
          },
        },
      },
    },
    null,
    2,
  );
}

export const userAgentAccessTokenService = {
  list: async (): Promise<UserAgentAccessTokenListItem[]> => {
    const response = await api.get<UserAgentAccessTokenListItem[]>(base);
    return response.data;
  },

  create: async (body: CreateUserAgentAccessTokenRequest): Promise<UserAgentAccessTokenCreated> => {
    const response = await api.post<UserAgentAccessTokenCreated>(base, body);
    return response.data;
  },

  revoke: async (id: number): Promise<void> => {
    await api.post(`${base}/${id}/revoke`);
  },

  whoami: async (): Promise<UserAgentWhoAmI> => {
    const response = await api.get<UserAgentWhoAmI>(`${base}/whoami`);
    return response.data;
  },
};

export default userAgentAccessTokenService;
